import $ from "jquery";
import cookie from "js-cookie";

import { staticURL } from "lib/img";

export default function initJQuery() {
    if ($.svgIcon) {
        return;
    }

    $.staticURL = staticURL;

    $.svgIcon = function svgIcon(icon, classes = "") {
        return (
            `<svg class="wsicon-${icon} ${classes} wsicon">` +
            `<use xlink:href="#wsicon-${icon}"/>` +
            "</svg>"
        );
    };

    $.fn.disable = function disable() {
        const $el = $(this);
        $el.attr("disabled", "disabled").prop("disabled", true);
        return $el;
    };
    $.fn.enable = function enable() {
        const $el = $(this);
        $el.attr("disabled", null).prop("disabled", false);
        return $el;
    };
    $.fn.loading = function loading(isLoading) {
        const $el = $(this);
        if (isLoading) {
            $el.disable().addClass("loading");
        } else {
            $el.enable().removeClass("loading");
        }
        return $el;
    };

    $.fn.serializeHash = function serializeHash() {
        const vals = $(this).serializeArray();
        const obj = {};

        vals.forEach(({ name, value }) => {
            if (!obj[name]) {
                obj[name] = value;
            } else {
                if (!Array.isArray(obj[name])) {
                    obj[name] = [obj[name]];
                }

                obj[name].push(value);
            }
        });

        return obj;
    };

    /* eslint-disable no-param-reassign, no-underscore-dangle */
    /**
     * Forces PATCH calls to send as POSTs to avoid old firewalls
     */
    $.ajaxPrefilter((options) => {
        const replacePatch = cookie.get("__wspatch");

        if (replacePatch && options.type === "PATCH") {
            options.type = "POST";
            options.headers = {
                ...options.headers,
                "WS-Method": "PATCH",
            };
        }
    });
    /* eslint-enable */
}
